export const IMAGES = {
  hero: "https://customer-assets-agu9un31.emergentagent.net/job_d4962cd0-a1bc-4584-a8e8-b6e8a6800bc1/artifacts/r0u96zs0_Gemini_Generated_Image_mp3zwcmp3zwcmp3z.png",
  portrait: "/images/venue-portrait.jpg",
  piaffe: "/images/piaffe-crop.jpg",
};

export const WHATSAPP_DISPLAY = "+971 58 575 4221";
export const WHATSAPP_URL =
  "https://wa.me/971585754221?text=" +
  encodeURIComponent(
    "Hello Kiara, I would like to enquire about winter training at my stables."
  );
export const EMAIL = "Kiara.c.d.smsn@gmail.com";

export const scrollToSection = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
